export default function Machines_A_0 (number = 1) {
  return {
    name: '电力感应塔',
    icon: '/static/img/machines/a0.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_A/Machines_A_0.js